import React, { useState, useLayoutEffect } from "react";
import { Layout, Spin } from "antd";
import "antd/dist/reset.css";
import { IMAGE_BASE_URL, USER_DETAIL } from "../../../constants/api";
import LS_SERVICE from "../../../utils/localStorage";
import assets from "../../../utils/ImagesPath";
import HeaderComponent from "./widgets/HeaderComponent";
import CommonBookingForm from "./widgets/CommonBookingForm";
import FooterComponent from "./widgets/FooterComponent";
import { postAPI } from "../../../utils/common";
import ProfileUpdateForm from "../../profile/ProfileUpdateForm";
import MyBookingTable from "./MyBookingTable";
import ErrorWidget from "../../404/ErrorWidget";

const { Content } = Layout;

const CommonBooking = () => {
  const { logo } = LS_SERVICE.get("setting") || {};
  const logoSrc = logo ? `${IMAGE_BASE_URL}${logo}` : assets.logo;
  const { company_name } = LS_SERVICE.get("setting") || {};

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  const getUserData = async () => {
    const data = new FormData();
    data.append("id", LS_SERVICE.get("id"));

    const successFn = (data) => {
      if (data.status === true) {
        LS_SERVICE.set("name", data.user.name);
        LS_SERVICE.set("user_type", data.user.user_type);
        LS_SERVICE.set("phone", data.user.phone);
        LS_SERVICE.set("email", data.user.email);
        LS_SERVICE.set("isCustomer", true);
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    };

    const errorFn = () => {
      setIsLoggedIn(false);
    };

    await postAPI(USER_DETAIL, data, successFn, errorFn);
  };

  useLayoutEffect(() => {
    const loadData = async () => {
      setLoading(true);
      if (LS_SERVICE.get("id") && LS_SERVICE.get("user_type") === "customer") {
        await getUserData();
      }
      setLoading(false);
    };

    loadData();
  }, []);

  const renderContent = () => {
    if (activeTab === "1") return <CommonBookingForm />;
    if (activeTab === "2")
      return LS_SERVICE.get("id") &&
        LS_SERVICE.get("user_type") === "customer" ? (
        <MyBookingTable />
      ) : (
        <ErrorWidget />
      );
    if (activeTab === "3")
      return LS_SERVICE.get("id") &&
        LS_SERVICE.get("user_type") === "customer" ? (
        <ProfileUpdateForm />
      ) : (
        <ErrorWidget />
      );
    return null;
  };

  return (
    <Layout>
      <HeaderComponent
        logoSrc={logoSrc}
        company_name={company_name}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <Layout>
        <Content className="content" style={{ padding: "24px" }}>
          {loading ? <Spin /> : renderContent()}
        </Content>
      </Layout>

      <FooterComponent />
    </Layout>
  );
};

export default CommonBooking;
